import React from 'react';
import { Rocket } from 'lucide-react';
import { Text } from '../ui';

const NoPostsCard = ({ shouldUpgrade, onUpgrade }) => {
  return (
    <div
      className='tour-no-posts-card rounded-xl p-8 flex flex-col md:flex-row items-center gap-6 justify-between'
      style={{
        background: 'var(--bg-surface)',
        border: '2px dashed var(--border)',
      }}
    >
      {shouldUpgrade ? (
        <>
          <div className='flex flex-col md:flex-row items-center gap-6 text-center md:text-left'>
            <div
              className='w-16 h-16 rounded-full flex items-center justify-center shrink-0'
              style={{
                background: 'rgba(251,191,36,0.15)',
                color: '#f59e0b',
                boxShadow: '0 0 0 4px rgba(251,191,36,0.08)',
              }}
            >
              <Rocket className='w-8 h-8' />
            </div>
            <div>
              <h3 className='text-xl font-bold' style={{ color: 'var(--text-primary)' }}>
                Unlock More Posts
              </h3>
              <Text variant='body' className='mt-1 max-w-2xl' style={{ color: 'var(--text-muted)' }}>
                Your current view is limited. Upgrade your plan to see all scheduled content and
                manage more posts effectively.
              </Text>
            </div>
          </div>
          <button
            className='font-semibold py-3 px-8 rounded-lg transition-all whitespace-nowrap cursor-pointer'
            style={{ background: 'var(--brand)', color: '#0A1610' }}
            onClick={onUpgrade}
          >
            Upgrade Now
          </button>
        </>
      ) : (
        <>
          <div className='flex flex-col md:flex-row items-center gap-6 text-center md:text-left'>
            <div
              className='w-16 h-16 rounded-full flex items-center justify-center shrink-0'
              style={{
                background: 'var(--bg-card-alt)',
                color: 'var(--text-muted)',
                boxShadow: '0 0 0 4px var(--bg-surface)',
              }}
            >
              <Rocket className='w-8 h-8' />
            </div>
            <div>
              <h3 className='text-xl font-bold' style={{ color: 'var(--text-primary)' }}>
                No Posts Available
              </h3>
              <Text variant='body' className='mt-1 max-w-2xl' style={{ color: 'var(--text-muted)' }}>
                You currently have no scheduled posts. Once you create and schedule posts, they will
                appear here for easy management.
              </Text>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NoPostsCard;
